module.exports = __webpack_public_path__ + "media/npc_dota_hero_puck.02a884ee.webm";